import { Component, h, Host, Prop } from '@stencil/core';

@Component({
  tag: 'uui-themed-background',
  shadow: true,
  styleUrl: 'uui-themed-background.css'
})
export class UUIThemedBackground {
  @Prop({reflect: true}) checkeredBackground = true;
  render() {
    const className = this.checkeredBackground ? 'checkered' : '';
    return (
      <Host>
        <div class={className}>
          <slot />
        </div>
      </Host>
    );
  }
}
